// No ENV support in CRA5 currently https://github.com/facebook/create-react-app/issues/11951

const config = {
  MAPBOX_API_KEY: 'pk.eyJ1IjoiamptYXJkZXYiLCJhIjoiY2t6c2lpZzFkNzMzbTJ2bXp2ZHE0YmZmeSJ9.g5IUCHWv96O7N0_RbmoXLw',
  API_HOST: 'https://tfscalls.fly.dev/'
}

export default config;
